export default __webpack_public_path__ + "static/timeline-cropped-78215a8643334ca7756e842d834c1b2d.png";